exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.addDataSection {\n  background-color: rgba(0, 0, 0, 0.5);\n  height: 80px;\n  z-index:990 !important;\n}\n\n", ""]);

// exports
